import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import "./RequesterDashboard.css";
import { LogoutButton } from "../Common/LogoutButton";
// import RideHistoryButton from "../Common/RideHistoryButton";
// import companyLogo from "../../Assets/logo.png";
import { apiFetch } from "../../utils/api";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const socket = io(BASE_URL,{withCredentials: true});

const RequesterDashboard = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [rideHistory, setRideHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedRideId, setSelectedRideId] = useState(null);
  const [rideProgress, setRideProgress] = useState(0);
  const [rideId, setRideId] = useState(null);
  const [rideStatus, setRideStatus] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [socket, setSocket] = useState(null);
  const [userName, setUserName] = useState("");
  const [tokenNo, setTokenNo] = useState("");
  const [rideTimestamps, setRideTimestamps] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  const SOCKET_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const storedUserString = localStorage.getItem("user");

    if (!storedUserString) {
      navigate("/signin", { replace: true });
      return;
    }

    try {
      const storedUser = JSON.parse(storedUserString);
      // console.log("requestef = ", storedUser);
      setUserName(storedUser.name.split(" ")[0]);
      setTokenNo(storedUser.token_no);
      if (storedUser.token_no === "F0612") {
        setIsAdmin(true); // Set admin flag for special user
      }

      fetchRideHistory(storedUser.token_no);
    } catch (err) {
      console.error("Failed to parse stored user:", err);
      navigate("/signin", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const newSocket = io(SOCKET_URL, { autoConnect: true,withCredentials: true });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("✅ Connected to available rides Socket.IO server");
    });

    newSocket.on("disconnect", () => {
      console.log(" Disconnected from available rides Socket.IO server");
    });

    newSocket.onAny((event, ...args) => {
      console.log(` Received event: ${event}`, args);
    });

    newSocket.on("rideAccepted", (data) => {
      const { rideId: acceptedRideId } = data;
      if (acceptedRideId === rideId) {
        setRideStatus("accepted");
        setRideProgress(2); // Fixed: Changed from 1 to 2
        setShowConfetti(true);
        setIsRequesting(false);
        localStorage.removeItem("isRequesting");

        const updatedHistory = [...rideHistory];
        const rideIndex = updatedHistory.findIndex(
          (ride) => ride.rideId === rideId
        );
        if (rideIndex !== -1) {
          updatedHistory[rideIndex].status = "ongoing";
          setRideHistory(updatedHistory);
          localStorage.setItem("rideHistory", JSON.stringify(updatedHistory));
        }
      }
    });

    newSocket.on("materialPicked", (data) => {
      if (data.rideId === rideId) {
        setRideProgress(3);
      }
    });

    newSocket.on("materialDropped", (data) => {
      if (data.rideId === rideId) {
        setRideProgress(4);
      }
    });

    newSocket.on("rideEnded", (data) => {
      if (data.rideId === rideId) {
        setRideProgress(5); // Fixed: Changed from 4 to 5

        setTimeout(() => {
          setRideProgress(0);
          setRideStatus("");
          setFromLocation("");
          setToLocation("");
          setRideId(null);
        }, 5000);
      }
    });

    return () => {
      newSocket.disconnect();
      console.log(" Disconnected from Socket.IO server");
    };
  }, [rideId, rideHistory]);

  const handleOptionSelection = (option) => {
    setSelectedOption(option);
  };

  const handleBookRide = (rideType) => {
    navigate(rideType);
    socket.emit("newRideRequest", {
      message: "A new ride has been booked!",
    });
  };

  const fetchRideHistory = async (userId) => {
    // console.log("userId = ", userId);
    try {
      const data = await apiFetch(`/api/ride-history/user?userId=${userId}`);
      // console.log("ride history = ", data);
      setRideHistory(data.history || []);
    } catch (error) {
      console.error("Error fetching ride history:", error);
    }
  };

  const handleRideClick = async (ride) => {
    const clickedRideId = ride.RIDEID;
    const status = ride.STATUS;

    if (!clickedRideId) return;

    console.log("🔍 Clicked ride:", { clickedRideId, status });

    setSelectedRideId(clickedRideId);
    setRideId(clickedRideId);
    setShowHistory(false);

    // Set initial progress based on status immediately
    const initialProgress = getInitialProgressFromStatus(status);
    console.log("📊 Initial progress:", initialProgress);
    setRideProgress(initialProgress);

    // Fetch additional data
    await fetchRideStatus(clickedRideId);
    await fetchRideTimestamps(clickedRideId);
  };

  const toggleHistory = () => {
    setShowHistory(!showHistory);
    // Reset selected ride when toggling history
    if (!showHistory) {
      setSelectedRideId(null);
      setRideProgress(0);
      setRideTimestamps({});
    }
  };

  // Updated formatDate function to use local_time if available
  const formatDate = (timestamp, localTime) => {
    // If local_time is available from backend, use it
    if (localTime) {
      return localTime;
    }
    // Otherwise, fallback to timestamp
    return timestamp || "";
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "completed":
        return "#10b981";
      case "ongoing":
        return "#3b82f6";
      case "requested":
        return "#f59e0b";
      default:
        return "#64748b";
    }
  };

  // Fixed the progress mapping to match your progress steps
  const getInitialProgressFromStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "requested":
        return 1;
      case "accepted":
        return 2;
      case "started":
        return 2; // Driver assigned
      case "material picked":
        return 3;
      case "delivered":
        return 4;
      case "completed":
        return 5; // All steps completed
      default:
        return 0;
    }
  };

  const fetchRideStatus = async (rideId) => {
    try {
      const clickedRide = await apiFetch(`/api/tracking/ride-status/${rideId}`);

      if (!clickedRide || !clickedRide.STATUS) {
        console.warn("⚠️ No status found for rideId:", rideId);
        return;
      }

      console.log("✅ Fetched ride status:", clickedRide.STATUS);

      // Update progress based on fetched status
      const progress = getInitialProgressFromStatus(clickedRide.STATUS);
      console.log("📊 Updated progress:", progress);

      setRideProgress(progress);
      setRideStatus(clickedRide.STATUS);
    } catch (err) {
      console.error("🚨 Error in fetchRideStatus:", err.message);
    }
  };

  const fetchRideTimestamps = async (rideId) => {
    try {
      const result = await apiFetch(`/api/bookings/get-timestamps/${rideId}`);
      const timestamps = result.timestamps || {};
      // console.log("📅 rideTimestamps =", timestamps);
      setRideTimestamps(timestamps);
    } catch (error) {
      console.error("❌ Error fetching timestamps:", error);
    }
  };

  const ProgressStep = ({ number, title, active, completed }) => (
    <div className="progress-step">
      <div
        className={`progress-circle ${active ? "active" : ""} ${
          completed ? "completed" : ""
        }`}
      >
        {completed ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        ) : (
          number
        )}
      </div>
      <div className={`progress-title ${active ? "active" : ""}`}>{title}</div>
    </div>
  );

  const ProgressConnector = ({ active }) => (
    <div className={`progress-connector ${active ? "active" : ""}`} />
  );

  const handleMaintenanceClick = async () => {
    try {
      const response = await apiFetch("/api/maintenance/verify-access");
      if (response.success) {
        navigate("/maintenance-head", { state: { fromAdmin: true } });
      } else {
        toast.error("Unauthorized access");
      }
    } catch (err) {
      console.error("Authorization failed:", err);
      toast.error(
        "You are not authorized to access Maintenance Head Dashboard."
      );
    }
  };

  return (
    <div className="requester-dashboard">
      {userName && !showHistory && !selectedRideId && (
        <div className="top-header">
          <div>
            <h1 className="hello-large">Hello, {userName}</h1>
            <p className="token-under-hello">Token: {tokenNo}</p>
            {isAdmin && (
              <button
                className="maintenance-button-left"
                onClick={handleMaintenanceClick}
                style={{
                  backgroundColor: "#ef4444", // red-500
                  color: "white",
                  border: "none",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.5rem",
                  fontSize: "0.875rem",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  transition: "all 0.2s ease",
                  marginTop: "0.5rem",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#dc2626"; // red-600
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#ef4444"; // red-500
                  e.target.style.transform = "translateY(0)";
                }}
              >
                🛠 Maintenance Panel
              </button>
            )}
          </div>
          <div className="logout-btn">
            <LogoutButton />
          </div>
        </div>
      )}

      <div className="background-overlay" />

      {/* Title at top */}
      <h2
        className="dashboard-title-top"
        style={{
          color: "white",
          fontWeight: "bold",
          marginLeft: "1rem",
          marginTop: "3rem",
          fontSize: "1.5rem",
          textAlign: "center",
        }}
      >
        {showHistory
          ? "Your Ride History"
          : selectedRideId
          ? `Ride Status for Ride ID: ${selectedRideId}`
          : "Type of Booking Required"}
      </h2>

      {/* Ride Progress Tracker - Fixed condition */}
      {selectedRideId && rideProgress > 0 && (
        <div className="ride-progress-tracker">
          <div className="progress-steps">
            <ProgressStep
              number={1}
              title="Requested"
              active={rideProgress === 1}
              completed={rideProgress > 1}
            />
            {rideTimestamps.start_time && (
              <div className="progress-timestamp">
                Start: {formatDate(rideTimestamps.start_time)}
              </div>
            )}
            <ProgressConnector active={rideProgress > 1} />

            <ProgressStep
              number={2}
              title="Driver Assigned"
              active={rideProgress === 2}
              completed={rideProgress > 2}
            />
            <ProgressConnector active={rideProgress > 2} />

            <ProgressStep
              number={3}
              title="Material Picked"
              active={rideProgress === 3}
              completed={rideProgress > 3}
            />
            {rideTimestamps.material_pick_time && (
              <div className="progress-timestamp">
                Picked:{" "}
                {new Date(rideTimestamps.material_pick_time).toLocaleString()}
              </div>
            )}
            <ProgressConnector active={rideProgress > 3} />

            <ProgressStep
              number={4}
              title="Delivered"
              active={rideProgress === 4}
              completed={rideProgress > 4}
            />
            {rideTimestamps.material_drop_time && (
              <div className="progress-timestamp">
                Dropped:{" "}
                {new Date(rideTimestamps.material_drop_time).toLocaleString()}
              </div>
            )}
          </div>

          <button
            className="button"
            onClick={() => {
              setSelectedRideId(null);
              setRideProgress(0);
              setRideTimestamps({});
            }}
          >
            ← Back to Dashboard
          </button>
        </div>
      )}

      {/* History View */}
      {showHistory && !selectedRideId ? (
        <div className="ride-history-container">
          <div className="history-header">
            <h3 style={{ color: "white" }}>Your Ride History</h3>
            <button className="button back-button-top" onClick={toggleHistory}>
              ⬅ Back
            </button>
          </div>
          {rideHistory.length > 0 ? (
            <div className="history-list">
              {rideHistory.map((ride, index) => (
                <div
                  key={index}
                  className="history-item"
                  onClick={() => handleRideClick(ride)}
                >
                  <div className="history-route">
                    <span className="from-location">{ride.FROM_LOCATION}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#64748b"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                    <span className="to-location">{ride.TO_LOCATION}</span>
                  </div>
                  <div className="history-details">
                    <span className="history-time">
                      {ride.ESTIMATED_TIME} min
                    </span>
                    <span
                      className="history-status"
                      style={{
                        backgroundColor: getStatusColor(ride.STATUS),
                      }}
                    >
                      {ride.STATUS}
                    </span>
                    <span className="history-date">
                      {formatDate(ride.TIMESTAMP, ride.LOCAL_TIME)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-history">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <p>No ride history found</p>
            </div>
          )}
        </div>
      ) : null}

      {/* Ride Booking UI */}
      {!showHistory && !selectedRideId && (
        <div className="dashboard-container">
          <p className="dashboard-subtext">Please select your ride type.</p>

          <div className="button-wrapper">
            <button
              className={`button fixed-ride ${
                selectedOption === "fixed" ? "selected" : ""
              }`}
              onClick={() => {
                handleOptionSelection("fixed");
                handleBookRide("/available-rides");
              }}
            >
              Fixed Ride
            </button>
            <button
              className={`button special-task ${
                selectedOption === "special" ? "selected" : ""
              }`}
              onClick={() => {
                handleOptionSelection("special");
                handleBookRide("/special-task-ride");
              }}
            >
              Special Task Ride
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequesterDashboard;
